import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=6c7c3011&"
import script from "./contacts.vue?vue&type=script&lang=js&"
export * from "./contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapMain: require('/var/www/components/map/map-main.vue').default,ContactsSlider: require('/var/www/components/contacts/contacts-slider.vue').default})
